import * as React from "react";
import * as ReactDOM from "react-dom";
import * as $ from "jquery";

export interface ExpandableTextControlProps {
    maxCollapsedLines: number;
    expandTitle: string;
    collapseTitle: string;
    content: string;
    className?: string;
}
export interface ExpandableTextControlState {
    expanded: boolean;
    expandable: boolean;
    singleLine: boolean;
}

export class ExpandableTextControl extends React.Component<ExpandableTextControlProps, ExpandableTextControlState> {
    constructor(props: ExpandableTextControlProps) {
        super(props);
        this.state = { expanded: false, expandable: false, singleLine: false };
    }

    public componentDidMount() {
        var text = $(ReactDOM.findDOMNode(this.refs['root'])).find('>span')[0];
        if (text) {
            var textHeight = text.scrollHeight;
            if (textHeight > $(text).innerHeight()) {
                this.setState({expandable: true, expanded: false});
            } else {
                if (textHeight < parseFloat($(text).css('line-height')) * parseInt($(text).css('font-size')) * 2) {
                    this.setState({singleLine: true});
                }
            }
        }
    }

    public componentWillUnmount() {            
    }

    private toggle() {
        this.setState({expanded: !this.state.expanded});
    }

    public render(): JSX.Element {
        var more = <div ref="exapndo"
            className={this.state.expandable ? "expando" : "expando hidden"}
            onClick={() => this.toggle()}
            >{this.state.expanded ? this.props.collapseTitle : this.props.expandTitle}</div>;
        var classes = `${this.props.className || ''} expandable-text ${this.state.expanded ? 'expanded' : 'collapsed'} ${this.state.singleLine ? 'single-line' : ''}`;
        return (
            <div ref="root" className={classes}>
                {this.props.content}
                {more}
            </div>
            );
    }
}



// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Views/ExpandableTextControl.tsx